import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';

export type UpdatePositionsInstrumentAction = {
    type: 'updatePositionsInstrument' | 'linkingUpdatePositionsInstrument';
    tabId: string;
    instrument: Instrument;
};
export const updatePositionsInstrument = (
    tabId: string,
    instrument: Instrument,
    isLinking = false,
): UpdatePositionsInstrumentAction => ({
    tabId,
    instrument,
    type: isLinking ? 'linkingUpdatePositionsInstrument' : 'updatePositionsInstrument',
});

export type UpdatePositionsAccountAction = { type: 'updatePositionsAccount'; tabId: string; accountId: string };
export const updatePositionsAccount = (tabId: string, accountId: string): UpdatePositionsAccountAction => ({
    type: 'updatePositionsAccount',
    tabId,
    accountId,
});

export type UserDoubleClickedPositionFromTableAction = {
    type: 'userDoubleClickedPositionFromTable';
    symbol?: string;
    accountId?: string;
    quantity?: number;
    tabId: string;
};

export const userDoubleClickedPosition = (
    tabId: string,
    symbol?: string,
    accountId?: string,
    quantity?: number,
): UserDoubleClickedPositionFromTableAction => ({
    symbol,
    accountId,
    quantity,
    tabId,
    type: 'userDoubleClickedPositionFromTable',
});

export type PositionsActions =
    | UpdatePositionsAccountAction
    | UpdatePositionsInstrumentAction
    | UserDoubleClickedPositionFromTableAction;
